import React from 'react';

const SHARED_CSS = `
.block-mobile {
  display: none;
}
.block-desktop {
  display: block;
}
@media screen and (max-width: 599.95px) {
  .block-mobile {
    display: block !important;
  }
  .block-desktop {
    display: none !important;
  }
}
@container (max-width: 599.95px) {
  .block-mobile {
    display: block !important;
  }
  .block-desktop {
    display: none !important;
  }
}
`;

export default function GlobalSharedStyle() {
  return <style dangerouslySetInnerHTML={{ __html: SHARED_CSS }} />;
}
